
    const _ = require("underscore");
    module.exports = function(context){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="loading-square ';
 if (context && context.isWhite) { 
__p+='loading-square--white';
 } 
__p+='"><div class="loading-square__lr"></div><div class="loading-square__tb"></div></div>';
return __p;
};
    